export default "__VITE_ASSET__038e4059__"